/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TypePolicies } from '@apollo/client';

const ChartCacheTypePolicies: TypePolicies = {
  ChartData: {
    fields: {
      results: {
        merge: (_existing, incoming) => {
          return incoming;
        },
      },
    },
  },
};

export { ChartCacheTypePolicies };
